// Sheet opener controller - opens Google Sheets in new tab after export
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    if (this.hasUrlValue && this.urlValue) {
      // Open the sheet in a new tab
      window.open(this.urlValue, '_blank')
    }
  }
}
